import { render, staticRenderFns } from "./requestrrdsebagianfrm.vue?vue&type=template&id=0c763dc4&scoped=true&"
import script from "./requestrrdsebagianfrm.vue?vue&type=script&lang=js&"
export * from "./requestrrdsebagianfrm.vue?vue&type=script&lang=js&"
import style0 from "./requestrrdsebagianfrm.vue?vue&type=style&index=0&id=0c763dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c763dc4",
  null
  
)

export default component.exports